export default "__VITE_ASSET__ffc27c75__"